import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

export const AdminTableSection = ({
  title,
  description,
  rows,
  columns,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  toolbar,
  onExport,
  exportLabel,
  emptyText,
  actions = [],
  testId,
}) => {
  return (
    <Card className="border-0 shadow-xl" data-testid={`${testId}-panel`}>
      <CardHeader className="space-y-4">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
          <div>
            <CardTitle className="text-2xl" style={{ color: '#7e2f22' }}>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          <div className="flex flex-col md:flex-row gap-3 w-full lg:w-auto">
            <Input
              value={searchValue}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder={searchPlaceholder}
              className="min-w-[240px]"
              data-testid={`${testId}-search-input`}
            />
            <Button onClick={onExport} style={{ backgroundColor: '#53a5ca' }} className="text-white" data-testid={`${testId}-export-button`}>
              {exportLabel}
            </Button>
          </div>
        </div>
        {toolbar ? <div className="flex flex-wrap gap-3">{toolbar}</div> : null}
      </CardHeader>
      <CardContent>
        {rows.length ? (
          <Table data-testid={`${testId}-table`}>
            <TableHeader>
              <TableRow>
                {columns.map((column) => (
                  <TableHead key={column.key}>{column.label}</TableHead>
                ))}
                {actions.length ? <TableHead>Actions</TableHead> : null}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id} data-testid={`${testId}-row-${row.id}`}>
                  {columns.map((column) => (
                    <TableCell key={`${row.id}-${column.key}`}>{column.render ? column.render(row) : row[column.key]}</TableCell>
                  ))}
                  {actions.length ? (
                    <TableCell>
                      <div className="flex flex-wrap gap-2">
                        {actions.map((action) => (
                          <Button
                            key={action.label}
                            variant="outline"
                            size="sm"
                            onClick={() => action.onClick(row)}
                            className={action.className}
                            data-testid={action.testId(row)}
                          >
                            {action.label(row)}
                          </Button>
                        ))}
                      </div>
                    </TableCell>
                  ) : null}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="rounded-2xl border border-dashed p-8 text-center text-gray-500" data-testid={`${testId}-empty-state`}>
            {emptyText}
          </div>
        )}
      </CardContent>
    </Card>
  );
};